import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon';
import DropZoneFileManager from 'components/DropZone/DropZoneFileManager';
import { ModalWrapper, ModalInner } from './UploaderView.styles';
import constants from './constants';

function UploadManagerModal({
  isOpen,
  onSaveRequest,
  onCloseRequest,
  objectId,
  contentType,
}) {
  const _onSaveRequest = useCallback(
    (images) => {
      const data = {
        imageMap: images[0].saved.id,
        src: '',
        type: constants.PLUGIN_TYPE,
        display: 'small',
      };
      onSaveRequest(data);
    },
    [onSaveRequest]
  );

  return (
    <div>
      {isOpen ? (
        <ModalWrapper className="table-manager-modal">
          <ModalInner>
            <Icon
              style={{ position: 'absolute', top: '10px', right: '10px' }}
              icon="icon-close"
              buttonStyle
              onClick={onCloseRequest}
              fontSize="15px"
            />

            <DropZoneFileManager
              type="upload"
              onClickThumbnail={(img) => {
                _onSaveRequest([img.data]);
              }}
              isImage
              showUploadAndRender
              objectId={objectId}
              contentType={contentType}
              disableDelete
              onSaved={_onSaveRequest}
              renderHeader={() => <div style={{ marginBottom: '10px' }} />}
            />
          </ModalInner>
        </ModalWrapper>
      ) : null}
    </div>
  );
}

UploadManagerModal.propTypes = {
  isOpen: PropTypes.bool,
  onSaveRequest: PropTypes.func,
  onCloseRequest: PropTypes.func,
  objectId: PropTypes.number,
  contentType: PropTypes.number,
};

export default UploadManagerModal;
